import React from 'react';
import ReactDOM from 'react-dom';
import 'utilities/extend';
import { rootStore } from './stores/RootStore';
import { AppContainer } from 'react-hot-loader';
import { Router } from 'react-router-dom';
import App from './App';
import { Provider } from 'mobx-react';
import history from 'utilities/history';

async function init() {
	let error = null;
	try {
		await rootStore.init();
	} catch (e) {
		rootStore.auth.errorMessage = e;
	}
	ReactDOM.render(
		<AppContainer>
			<Provider {...rootStore} root={rootStore}>
				<Router history={history}>
					<App error={error} />
				</Router>
			</Provider>
		</AppContainer>,
		document.getElementById('root')
	);
}

init();

if (process.env.NODE_ENV === 'development' && module.hot) {
	window.store = rootStore;
	module.hot.accept('./App', () => {
		render(App);
	});
}



// WEBPACK FOOTER //
// ./src/index.js